import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { ref, onMounted, reactive, nextTick, watch } from "vue";
import { useRouter } from 'vue-router';
import BannerSwiper from "@/components/BannerSwiper/index.vue";
import CompanyIntro from "@/pages/aboutUs/components/companyIntro.vue";
import Founder from "@/pages/aboutUs/components/founder.vue";
import Advantage from "@/pages/aboutUs/components/advantage.vue";
import TeamList from "@/pages/aboutUs/components/teamList.vue";
import Invest from "@/pages/aboutUs/components/invest.vue";
import ContactUs from "@/pages/aboutUs/components/contactUs.vue";
export default {
  components: {
    BannerSwiper: BannerSwiper,
    CompanyIntro: CompanyIntro,
    Founder: Founder,
    Advantage: Advantage,
    TeamList: TeamList,
    Invest: Invest,
    ContactUs: ContactUs
  },
  name: "aboutUs",
  setup: function setup() {
    var bannerList = reactive([{
      id: 0,
      // imageUrl: "https://cdn.tenacia.com/base/tenacia-img/about_banner1.png",
      imageUrl: require("@/pages/aboutUs/images/about_banner1.jpg") // imageUrl: 'https://insightin.oss-cn-beijing.aliyuncs.com/emarking/2024/yuanyiguanwang/images/about_banner.png',

    } // {
    // id: 0,
    // imageUrl: require("@/pages/aboutUs/images/about_banner_02.png"),
    // imageUrl: 'https://insightin.oss-cn-beijing.aliyuncs.com/emarking/2024/yuanyiguanwang/images/about_banner.png',
    // },
    // {
    //   id: 0,
    //   imageUrl: require("@/pages/aboutUs/images/about_banner_03.png"),
    //   // imageUrl: 'https://insightin.oss-cn-beijing.aliyuncs.com/emarking/2024/yuanyiguanwang/images/about_banner.png',
    // },
    ]); // console.log("bannerList=", bannerList.value)

    onMounted(function () {
      var hash = window.location.hash; // console.log('hash:', hash)

      if (hash.indexOf('#') != -1) {
        nextTick(function () {
          var id = hash.split('#')[1];
          id = decodeURIComponent(id);
          var el = document.getElementById(id); // console.log('滚动到：', id, el)

          if (el) {
            // 平滑滚动
            setTimeout(function () {
              el.scrollIntoView({
                behavior: 'smooth'
              });
            }, 200);
          }
        });
      }
    });
    var hash = window.location.hash;
    var router = useRouter(); // console.log('hash:', hash)

    watch(hash, function () {
      // router.go(0);
      onMounted();
    });
    return {
      bannerList: bannerList
    };
  }
};